import { render } from "./DisabledState.vue?vue&type=template&id=4322f662"
import script from "./DisabledState.vue?vue&type=script&lang=ts"
export * from "./DisabledState.vue?vue&type=script&lang=ts"
script.render = render

export default script